import { render } from "./MenuLayout.vue?vue&type=template&id=9ae1d846&scoped=true"
import script from "./MenuLayout.vue?vue&type=script&lang=js"
export * from "./MenuLayout.vue?vue&type=script&lang=js"

import "./MenuLayout.vue?vue&type=style&index=0&id=9ae1d846&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ae1d846"]])

export default __exports__